<template>
  <div>
    <Card class="p-shadow-1">
        <template #title>
            Confirmar
        </template>
        <template #content>            
            <p><strong>Dados selecionados.</strong> </p>
            <p>CNPJ: <strong>{{ cnpj.numero }} - {{ cnpj.razaoSocial }}</strong></p>
            <p>Funcionários: <strong>{{ funcionarios.length }}</strong></p>
            <p>Escala selecionada: <strong>{{ escalaSelecionada.nomeRef }}</strong></p>
            <p>Data de início da escala: <strong>{{ formatarData(dataIinicioEscala) }}</strong></p>
        </template>
        <template #footer>
          <div class="p-grid p-nogutter p-justify-between">
              <div>
                <Button label="Voltar" @click="anterior" icon="pi pi-angle-left" class="p-mr-2" />
                <Button label="Cancelar" @click="cancelar" icon="pi pi-times" class="p-button-secondary" />
              </div>
              <div>
                <Button label="Finalizar" @click="proximo" icon="pi pi-checked" />
              </div>
          </div>            
      </template>
    </Card>
  </div>
</template>

<script>

import FuncionarioService from '@/service/FuncionarioService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
  funcionarioService: null,
  data() {
    return { 
      dataIinicioEscala: new Date(),
      escalaSelecionada: {},
      funcionarios: [],    
      cnpj: {}
    }
  },
  methods: {
    ...mapGetters('sessao', ['getDadosRequisicao']),
    carregar() {
      let json = sessionStorage.getItem('empregadosArquivoCSV');
      sessionStorage.removeItem('empregadosArquivoCSV');
      let dados = JSON.parse(json);
      this.dataIinicioEscala = dados.dataIinicioEscala;
      this.escalaSelecionada = dados.escalaSelecionada;
      this.funcionarios = dados.funcionarios;
      this.cnpj = dados.cnpj;
    },
    proximo() {
      let requisicao = {		
				dataIinicioEscala: this.dataIinicioEscala,
        escala: this.escalaSelecionada,
        funcionarios: this.funcionarios,
        cnpj: this.cnpj,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
      this.funcionarioService.fnalizarImportarCSV(requisicao)        
				.then(resp => {                            
            exibirMensagem(this, resp);
            this.$emit('nextPage', {formData: {}, pageIndex: 2});
        })
        .catch(erro => {exibirMensagem(this, erro)});       
    },
    anterior() {
      this.$emit('prevPage', {formData: {}, pageIndex: 3});
    },
    cancelar() {
        this.$router.push('/cadastros/funcionarios');
    },
    formatarData(data) {
			let partes = data.split('-');
			const strData = partes[2] + '/' + partes[1] + '/' + partes[0];
			return strData;
		},
  },
  created() {
    this.carregar();
    this.funcionarioService = new FuncionarioService();
  }
}
</script>

<style>

</style>